import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onAddReminderRes } from "./helper";

const addReminder = async (data: AddReminderReqT) =>
  axios.post(Routes.ADD_REMINDER, data);

export const useAddReminder = () =>
  useMutation({
    mutationKey: [Keys.ADD_REMINDER_MUT],
    mutationFn: addReminder,
    onSuccess: onAddReminderRes,
  });
